import { ethers } from 'ethers'
import ABIS from './contractabis.js'
import { kulaApiFetch } from './kulaApiFetch.js'
import { featureFlags } from '../../utilities/feature-flags.js'

/**
 * @param {string} wallet_address - The address of the wallet the user wants to verify.
 * @returns {Promise<VerificationCodeResponse>}
 */
export function getVerificationCode(wallet_address) {
  // TODO: defunct pointing at old API endpoint
  return kulaApiFetch('/verifications/new', {
    method: 'POST',
    body: { wallet_address },
  }).then((res) => res.json())
}

/**
 * @param {string} userId - The id of the user to verify.
 */
export async function getWalletVerificationStatus(userId) {
  if (featureFlags.FF_WALLET_VERIFICATION) {
    return [{ status: 'approved' }]
  }

  // TODO: defunct pointing at old API endpoint
  try {
    return await kulaApiFetch(`/wallets/${userId}`, {
      method: 'GET',
    }).then((res) => res.json())
  } catch (error) {
    console.error('Error fetching wallet verification status:', error)
    return null
  }
}

/**
 * @description
 *
 *    Get's existing verification codes for a user.
 *
 * @param {string} userId
 * @returns {Promise<VerificationCodeResponse[]>}
 */
export function getUsersVerificationCodes(userId) {
  // TODO: defunct pointing at old API endpoint
  return kulaApiFetch(`/verifications/${userId}`, { method: 'GET' }).then(
    (res) => res.json()
  )
}

/**
 * @returns
 */
export function submitAccountVerification(
  accountId,
  verificationCode,
  verificationAddress
) {
  const contract = getVerificationContract({
    address: verificationAddress,
    abiMethods: ABIS.VERIFICATION.methods,
  })

  return contract.submitVerification(accountId, verificationCode)
}

/**
 * @returns
 */
export function getWalletStatus(accountId, verificationAddress) {
  const contract = getVerificationContract({
    address: verificationAddress,
    abiMethods: ABIS.VERIFICATION.methods,
  })

  return contract.accountStatus(accountId)
}

function getVerificationContract({ address, abiMethods }) {
  return new ethers.Contract(
    address,
    abiMethods,
    new ethers.providers.Web3Provider(window.ethereum).getSigner()
  )
}

export function getAccountUserView(wallet_address, verificationAddress) {
  const contract = getVerificationContract({
    address: verificationAddress,
    abiMethods: ABIS.VERIFICATION.methods,
  })
  return contract.getAccountUserView(wallet_address)
}
